import { render, staticRenderFns } from "./CertificateVertical.vue?vue&type=template&id=84ac9fce&scoped=true"
import script from "./CertificateVertical.vue?vue&type=script&lang=js"
export * from "./CertificateVertical.vue?vue&type=script&lang=js"
import style0 from "./CertificateVertical.vue?vue&type=style&index=0&id=84ac9fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ac9fce",
  null
  
)

export default component.exports